import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1';
import Icons from '~/Common-Objects/UI/Icons/index';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx';
import axios from '../../../../data/http/axios';
import moment from 'moment';
import i18n from '~/i18n';
import FormatNumberFuncs from '../../../../Classes/numberFormatFunctions';
import DateTimeFunctions from '../../../../Classes/dateTimeFunctions';

export default function SiteVisitTable({ edit = () => { } }) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const history = useHistory()

    const getData = async () => {
        setLoading(true)
        const res = await axios.get('/accountMaster/tracker')
        var trackersData = res.data.Trackers.map((tracker) => {
            var ourDomain = tracker.host;
            if (!tracker.host || !tracker.host.length) ourDomain = "unknown";
            return {
                domain: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.domain'),
                    value: ourDomain,
                    orderBy: false
                },
                hits: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.hits'),
                    value: <SquareChip className="square-chip-primary square-chip-large">{FormatNumberFuncs.formatNumber(tracker.hits)}</SquareChip>,
                    orderBy: false,
                    align: "center",
                    width: "100"
                },
                lastHit: {
                    headerValue: i18n.t('campaigns:sitetracking.trackingsites.lastHit'),
                    value: <span> {DateTimeFunctions.formatDateTime(tracker.lastHit)}</span>,
                    orderBy: false,
                    align: "center",
                    width: "200"
                }
            }
        })
        setData(trackersData)
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Paper isLoading={loading} iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={edit}>
            <div className="quickFlex mar-b24" style={{ justifyContent: "space-between" }}>
                <h4>Site Trackers</h4>
                <Row>
                    <Column xs={12} margin={0} className="end-xs">
                        <Button className="primary" iconRight={<Icons icon="arrowRight" />} onClick={() => history.push('/cp/trackers')}>View Site Trackers</Button>
                    </Column>
                </Row>
            </div>

            {!!data && <DataTable1
                noResultsTxt={"No Sites Configured"}
                tableData={data}
            />}
            {!data && <div style={{ height: 300 }}><LoadingIcons /></div>}
        </Paper>
    )
}